import React, { useEffect } from 'react';
import { store } from 'redux/store';
import { setCurrentTab } from 'redux/reducers/fluxAutomaticLayoutReducer';
import ClassicDesktop from 'components/Flux/Automatic/Classic/Desktop';
import ClassicMobile from 'components/Flux/Automatic/Classic/Mobile';
import useIsMobile from 'utils/hooks/useIsMobile';
import './index.scss';

export default function Classic() {
  const isMobile = useIsMobile();

  useEffect(() => {
    store.dispatch(setCurrentTab('classic'));
  });

  if (isMobile) {
    return <ClassicMobile />;
  }

  return <ClassicDesktop />;
}
